import React, { Component } from "react";
import { propertyUtil } from "views/Pma/PropertyUtil";
import testLogo from "./octavio-marquez-june-2024-logo.png";
import Constants from "common/constants";
import CompassPhotoEditModal from "./CompassPhotoEditModal";
import { COMPASS_CIRCLE_DISPLAY_SIZE } from "./getCroppedImg";
import "./print.scss";

const parseCompassCrop = (crop) => {
  if (!crop) return null;
  if (typeof crop === "string") {
    try {
      return JSON.parse(crop);
    } catch (e) {
      return null;
    }
  }
  return crop;
};

class QVFourLogoAndAvatar extends Component {
  state = {
    totalHeight: 0,
    compassPhotoModalOpen: false,
    croppedHeadshotURL: null,
    compassPhotoCrop: null,
  };
  compassHeadshotRef = React.createRef();

  openCompassPhotoModal = (event) => {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    this.setState({ compassPhotoModalOpen: true });
  };

  closeCompassPhotoModal = () => {
    this.setState({ compassPhotoModalOpen: false });
  };

  handleCompassPhotoSaved = ({ croppedHeadshotURL, compassPhotoCrop }) => {
    this.setState({
      croppedHeadshotURL,
      compassPhotoCrop,
      compassPhotoModalOpen: false,
    });
  };
  componentDidMount = () => {
    const elements = document.querySelectorAll("[class*='height-']");
    const heights = {};
    let totalHeight = 0;
    elements.forEach((el) => {
      const match = el.className.match(/height-(\d+)/);
      if (match) {
        const rowHeight = Number(match[1]);
        totalHeight += rowHeight;
      }
    });
    this.setState({
      totalHeight,
    });
  };

  formatAgentDesignation = (designation) => {
    const { listgenUserID } = this.props.agentData;
    let isWendyMarioni = listgenUserID === "102935";

    if (isWendyMarioni) {
      return "Realtor® | CIPS™ | ABR™ | Relocation Specialist";
    } else if (
      designation === "Realtor" ||
      designation === "Broker Associate | Realtor"
    ) {
      return `${designation}®`;
    } else {
      return `${designation}`;
    }
  };
  formatTagline = (tagline, containerClasses, textClasses) => {
    const { listgenUserID } = this.props.agentData;
    const { mlsAreaID } = this.props.currentArea;
    let split = tagline.split(Constants.LG_DEFAULT_TEXT_SEPARATOR);

    let isErikaDemma = listgenUserID === "106107";

    let extraClasses = "";

    if (mlsAreaID === "SCL-17G") {
      extraClasses = "";
    } else if (tagline && tagline.length > 60 && tagline.length < 67) {
      extraClasses = "small-tagline-text-12";
    } else if (
      tagline.includes(Constants.LG_DEFAULT_TEXT_SEPARATOR) &&
      ((split[0] && split[0].length > 51 && split[0] && split[0].length < 65) ||
        (split[1] &&
          split[1].length > 51 &&
          split[1] &&
          split[1] &&
          split[1].length < 65))
    ) {
      extraClasses = "small-tagline-text-12";
    } else if (
      tagline.includes(Constants.LG_DEFAULT_TEXT_SEPARATOR) &&
      ((split[0] && split[0].length > 51) || (split[1] && split[1].length > 51))
    ) {
      extraClasses = "small-tagline-text-10";
    }

    let secondTaglineClass;
    if (listgenUserID === "104742") {
      secondTaglineClass = "small-tagline-text-12";
    } else if (mlsAreaID === "SCL-16M") {
      secondTaglineClass = "italicized-no-bold-tagline";
    }
    if (isErikaDemma) {
      return (
        <div className={`address-city-mt larger-address-city-365`}>
          <div
            className={`address-city ${textClasses} ${extraClasses}`}
            dangerouslySetInnerHTML={{
              __html: split[0],
            }}
          ></div>
          {split[1] && (
            <div
              className={`address-city ${textClasses} ${extraClasses} ${secondTaglineClass}`}
              dangerouslySetInnerHTML={{
                __html: split[1],
              }}
            ></div>
          )}
          <div
            className={`address-city ${textClasses} ${extraClasses} ${secondTaglineClass}`}
          >
            Follow me on Instagram @luxrealestateservices
          </div>
        </div>
      );
    } else {
      return (
        <div className={`address-city-mt ${containerClasses}`}>
          <div
            className={`address-city ${textClasses} ${extraClasses}`}
            dangerouslySetInnerHTML={{
              __html: split[0],
            }}
          ></div>
          {split[1] && (
            <div
              className={`address-city ${textClasses} ${extraClasses} ${secondTaglineClass}`}
              dangerouslySetInnerHTML={{
                __html: split[1],
              }}
            ></div>
          )}
        </div>
      );
    }
  };

  renderAgentPhoto = ({
    photoURL,
    originalPhotoURL,
    isCompassAgent,
    agentPhotoStyle = "",
    agentPhotoContainerStyle = "",
    extraPhotoClass = "",
    extraContainerClass = "",
    agentData,
    listgenUserID,
    savedCrop,
  }) => {
    const { fromEditor } = this.props;
    const cropShape = (savedCrop && savedCrop.cropShape) || "rect";
    const isSquareCrop = cropShape === "rect";
    let showCroppedModal = false;
    if (isCompassAgent) {
      return (
        <>
          <div className="compass-photo-strip">
            <div className="compass-photo-strip-logo">
              <img
                src="https://d2onbxnrte2nim.cloudfront.net/Horizontal_White_Compass%20Logo_500px.png"
                alt="Compass"
              />
            </div>
            <div
              className={`compass-photo-strip-headshot${
                isSquareCrop ? " is-square-crop" : ""
              }`}
              ref={this.compassHeadshotRef}
              style={{
                width: COMPASS_CIRCLE_DISPLAY_SIZE,
                height: COMPASS_CIRCLE_DISPLAY_SIZE,
              }}
            >
              <img
                src={photoURL}
                alt="Agent"
                className={
                  originalPhotoURL && photoURL !== originalPhotoURL
                    ? "is-baked-circle"
                    : ""
                }
              />
            </div>
            {fromEditor && showCroppedModal && (
              <div
                className="compass-edit-photo-admin-btn"
                onClick={this.openCompassPhotoModal}
                role="button"
                tabIndex={0}
                onKeyDown={(event) => {
                  if (event.key === "Enter" || event.key === " ") {
                    this.openCompassPhotoModal(event);
                  }
                }}
              >
                ADMIN: Edit photo
              </div>
            )}
          </div>
          <CompassPhotoEditModal
            open={this.state.compassPhotoModalOpen}
            onClose={this.closeCompassPhotoModal}
            photoURL={originalPhotoURL || photoURL}
            listgenUserID={listgenUserID}
            agentData={agentData}
            savedCrop={savedCrop}
            headshotRef={this.compassHeadshotRef}
            onSaved={this.handleCompassPhotoSaved}
          />
        </>
      );
    }

    return (
      <div
        className={`agent-photo-container ${agentPhotoContainerStyle} ${extraContainerClass}`.trim()}
      >
        <img
          src={photoURL}
          className={`agent-photo ${agentPhotoStyle} ${extraPhotoClass}`.trim()}
          alt="Agent"
        />
      </div>
    );
  };

  render() {
    const { totalHeight } = this.state;

    const { formatTagline, renderAgentPhoto } = this;
    const { printVersion, agentData, currentArea } = this.props;
    let {
      logoURL,

      mobilePhoneNo,

      officePhoneNo,
      photoURL,
      isMemberOfTeam,
      listgenUserFirstName,
      listgenUserLastName,
      teamMembers,
      emailAddress,
      websiteURL,
      listgenUserID,
      teamName,
      displayEmailAddress,
      specialSignatureText,
      agentLicenseNumber,
      agentDesignation,
      brokerageName,
    } = agentData;

    const { mlsAreaID } = currentArea;
    const isCompassAgent =
      (typeof brokerageName === "string" &&
        brokerageName.includes("Compass") &&
        mlsAreaID.includes("SFO")) ||
      listgenUserID === "114847";
    const compassLayoutClass = isCompassAgent ? "compass-photo-layout" : "";

    if (
      listgenUserID === "107300" &&
      listgenUserFirstName &&
      !listgenUserFirstName.includes("Sen")
    ) {
      listgenUserFirstName += " Sen";
    }
    if (mlsAreaID === "CCA-4500M") {
      photoURL =
        "https://d2onbxnrte2nim.cloudfront.net/SueRubin-MikeO_GolfCart.jpg";
    }
    if (listgenUserID === "100474") {
      photoURL =
        "https://d2onbxnrte2nim.cloudfront.net/ch-team-photo-may-2025.jpg";
    }
    const savedCompassCrop = parseCompassCrop(
      this.state.compassPhotoCrop || agentData.compassPhotoCrop || null,
    );
    const displayedCompassPhotoURL =
      this.state.croppedHeadshotURL || agentData.croppedHeadshotURL || photoURL;
    if (listgenUserID === "x104412") {
      logoURL = testLogo;
    }
    if (listgenUserID === "107319") {
      logoURL =
        "https://d2onbxnrte2nim.cloudfront.net/Gohn-Marie-McFadden-4k-black.jpg";
    }
    if (listgenUserID === "102843") {
      isMemberOfTeam = false;
      teamMembers = [];
    }
    teamMembers = teamMembers || [];

    if (mlsAreaID === "ALA-3900AD") {
      mobilePhoneNo = officePhoneNo;
    }

    if (mlsAreaID === "SMA-307") {
      displayEmailAddress = "menlooaksrealestate@gmail.com";
      emailAddress = "menlooaksrealestate@gmail.com ";
    } else if (mlsAreaID === "SCL-209A") {
      displayEmailAddress = "CuestaPark.com";
      emailAddress = "cuestapark.com";
    } else if (mlsAreaID === "SCL-207A") {
      displayEmailAddress = "OldMountainView.com";
      emailAddress = "OldMountainView.com";
    } else if (mlsAreaID === "SCL-207B") {
      displayEmailAddress = "DowntownMountainView.com";
      emailAddress = "DowntownMountainView.com";
    } else if (mlsAreaID === "SCL-209C") {
      displayEmailAddress = "SaintFrancisAcres.com";
      emailAddress = "SaintFrancisAcres.com";
    }
    let isMarkWong = listgenUserID === "102450";

    let { tagLine } = currentArea;

    if (tagLine && tagLine.length > 2) {
      specialSignatureText = tagLine;
    }

    let isWendyLeung = listgenUserID === "105794";
    let isColleenForaker = listgenUserID === "106020";
    let isLeeShantePappas = listgenUserID === "104480";
    const isLoannT = listgenUserID === "116884";
    let isLynneMercer = listgenUserID === "102512";
    let smallerSignature = false;
    if (isLeeShantePappas) {
      listgenUserFirstName = "Lee + Shanté";
    }
    if (
      specialSignatureText &&
      specialSignatureText.length > 78 &&
      !specialSignatureText.includes(Constants.LG_DEFAULT_TEXT_SEPARATOR)
    ) {
      smallerSignature = "smaller-signature-text";
    }
    if (isMarkWong) {
      smallerSignature = "negative-signature-margin";
    }

    let isPerryGroup = listgenUserID === "101649";
    let isKazemiTeam = listgenUserID === "102712";

    let isCindyAndrade = listgenUserID === "102378";
    let isKyle3Team = listgenUserID === "103406";
    let isTeamOf3 =
      isMemberOfTeam &&
      Array.isArray(teamMembers) &&
      teamMembers.length >= 3 &&
      (listgenUserID === "109938" ||
        listgenUserID === "114847" ||
        listgenUserID === "109973" ||
        listgenUserID === "109657" ||
        listgenUserID === "109864" ||
        listgenUserID === "109879" ||
        listgenUserID === "116921" ||
        listgenUserID === "120373");
    let isKimmAndJennifer = listgenUserID === "106028";
    let isJohnForsythJames = listgenUserID === "102535";
    const isRoseD = listgenUserID === "116097";
    let addWebsiteUnderSignature = isRoseD;
    const { formatPhoneNoWithDashes, formatPhoneNoWithPeriods } = propertyUtil;
    let filteredBrokerage = "";
    const isScar = teamName === "Team Scarborough";
    const isSingleBerkshire =
      filteredBrokerage ===
      "Berkshire Hathaway HomeServices California Properties";
    const singleAgent2LineBerkshire = isSingleBerkshire && true;
    let isAnnetteVait = listgenUserID === "101001";
    if (isAnnetteVait) {
      logoURL =
        "https://d2onbxnrte2nim.cloudfront.net/non-covers/122623_AnnetteVait_LOGO-sans-ICON_1.png";
    }
    // console.log("listgenUserID", listgenUserID);
    //  console.log("currentArea", currentArea);
    const isMaryAyers = listgenUserID === "100059";
    const isJenMurry = listgenUserID === "106031";
    const isDaphneChou = listgenUserID === "102413";
    let isJohnsons = listgenUserID === "100988";
    const isDebKockos = listgenUserID === "106463";
    let backpageAgentInfoStyles;
    if (isJenMurry) {
      backpageAgentInfoStyles = "vano-maurry-agent-info";
    } else if (listgenUserID === "109973" || listgenUserID === "109938") {
      backpageAgentInfoStyles = "lined-up-divider";
    }
    let secondRowContactMeStyles;
    if (isMarkWong) {
      secondRowContactMeStyles = "contact-me-margin-neg-10";
    }

    let emailStyles;
    if (listgenUserID === "102288") {
      emailStyles = "email-reduced-margin-top";
    } else if (listgenUserID === "104504") {
      emailStyles = "team-email-no-margin";
    } else if (listgenUserID === "107280") {
      emailStyles = "margin-bottom-email-10";
    }
    let contactMeStyles = "";
    if (listgenUserID === "114384") {
      contactMeStyles = "cm-font-18";
    }
    //adding comment
    let logoMargin = "";
    let logoHeight = "";
    if (
      listgenUserID === "100129" ||
      listgenUserID === "100374" ||
      listgenUserID === "102699" ||
      listgenUserID === "105790" ||
      listgenUserID === "105527" ||
      listgenUserID === "102627" ||
      listgenUserID === "104709" ||
      listgenUserID === "100746" ||
      listgenUserID === "107010" ||
      listgenUserID === "104519" ||
      listgenUserID === "107037"
    ) {
      logoMargin = "small-mt-bottom-margin";
      logoHeight = "agent-logo-height-80-width-234";
    } else if (listgenUserID === "100528" || listgenUserID === "106463") {
      logoHeight = "agent-logo-height-110-width-265";
    } else if (
      listgenUserID === "100138" ||
      listgenUserID === "100411" ||
      listgenUserID === "105056" ||
      listgenUserID === "106421" ||
      listgenUserID === "104113" ||
      listgenUserID === "102808" ||
      listgenUserID === "104454" ||
      listgenUserID === "105915" ||
      listgenUserID === "105068"
    ) {
      logoHeight = "agent-logo-height-90-width-265";
    } else if (listgenUserID === "105100" || listgenUserID === "105959") {
      logoHeight = "agent-logo-height-104-width-265";
    } else if (listgenUserID === "106041") {
      logoHeight = "agent-logo-height-120-width-265";
    } else if (listgenUserID === "102286") {
      logoHeight = "agent-logo-height-90-width-245";
    } else if (listgenUserID === "101003") {
      logoMargin = "small-mt-bottom-margin";
    } else if (
      listgenUserID === "100568" ||
      listgenUserID === "100220" ||
      listgenUserID === "100401" ||
      listgenUserID === "100134" ||
      listgenUserID === "100210" ||
      listgenUserID === "100329" ||
      listgenUserID === "100227" ||
      listgenUserID === "100656" ||
      listgenUserID === "100187" ||
      listgenUserID === "101006" ||
      listgenUserID === "100462" ||
      listgenUserID === "100026" ||
      listgenUserID === "100474" ||
      listgenUserID === "100040" ||
      listgenUserID === "104626" ||
      listgenUserID === "102743" ||
      listgenUserID === "102674" ||
      listgenUserID === "102551" ||
      listgenUserID === "105801" ||
      listgenUserID === "102512" ||
      listgenUserID === "105810" ||
      listgenUserID === "105047" ||
      listgenUserID === "102941"
    ) {
      logoHeight = "agent-logo-height-80-width-234";
    } else if (listgenUserID === "105794" || listgenUserID === "104607") {
      logoHeight = "agent-logo-height-45-width-234";
    } else if (
      listgenUserID === "100988" ||
      listgenUserID === "100059" ||
      listgenUserID === "102481"
    ) {
      logoHeight = "agent-logo-height-80-width-181";
    } else if (isJenMurry || listgenUserID === "105642" || isDaphneChou) {
      logoHeight = "agent-logo-height-63-width-234";
    } else if (
      listgenUserID === "100588" ||
      listgenUserID === "100999" ||
      listgenUserID === "101677" ||
      listgenUserID === "106998" ||
      listgenUserID === "106997" ||
      listgenUserID === "106999" ||
      listgenUserID === "102734" ||
      listgenUserID === "106145" ||
      listgenUserID === "106433" ||
      listgenUserID === "102535" ||
      listgenUserID === "107253"
    ) {
      logoHeight = "agent-logo-height-80-width-265";
    } else if (isAnnetteVait || listgenUserID === "105867") {
      logoHeight = "agent-logo-height-25-width-245";
    } else if (
      listgenUserID === "100028" ||
      listgenUserID === "102288" ||
      listgenUserID === "102712" ||
      listgenUserID === "102843" ||
      listgenUserID === "105222" ||
      listgenUserID === "101313" ||
      listgenUserID === "105896" ||
      listgenUserID === "106028" ||
      listgenUserID === "105882" ||
      listgenUserID === "104849" ||
      listgenUserID === "106399" ||
      listgenUserID === "105799" ||
      listgenUserID === "105042"
    ) {
      logoHeight = "agent-logo-height-80-width-265";
    } else if (listgenUserID === "100152") {
      logoHeight = "agent-logo-height-80-width-234";
    } else if (
      listgenUserID === "103404" ||
      listgenUserID === "104412" ||
      listgenUserID === "105678" ||
      listgenUserID === "102660" ||
      listgenUserID === "101479" ||
      listgenUserID === "104819" ||
      listgenUserID === "106647" ||
      listgenUserID === "106578" ||
      listgenUserID === "102694" ||
      listgenUserID === "102809" ||
      listgenUserID === "102507" ||
      listgenUserID === "102995" ||
      listgenUserID === "106024" ||
      listgenUserID === "106543" ||
      listgenUserID === "106472" ||
      listgenUserID === "106141" ||
      listgenUserID === "106661" ||
      listgenUserID === "105189" ||
      listgenUserID === "105797" ||
      listgenUserID === "106144" ||
      listgenUserID === "107012" ||
      listgenUserID === "107001" ||
      listgenUserID === "104874"
    ) {
      logoHeight = "agent-logo-height-90-width-265";
    } else if (
      listgenUserID === "103405" ||
      listgenUserID === "105789" ||
      listgenUserID === "104683" ||
      listgenUserID === "102935" ||
      listgenUserID === "105016" ||
      listgenUserID === "102802" ||
      listgenUserID === "102501" ||
      listgenUserID === "102548" ||
      listgenUserID === "105886" ||
      listgenUserID === "105103" ||
      listgenUserID === "107009" ||
      listgenUserID === "105805" ||
      listgenUserID === "106591" ||
      listgenUserID === "101332" ||
      listgenUserID === "101268" ||
      listgenUserID === "107319"
    ) {
      logoHeight = "agent-logo-height-69-width-234";
    } else if (
      listgenUserID === "100348" ||
      listgenUserID === "100778" ||
      listgenUserID === "100314" ||
      listgenUserID === "100528" ||
      listgenUserID === "104597" ||
      listgenUserID === "104510" ||
      listgenUserID === "105787" ||
      listgenUserID === "102687" ||
      listgenUserID === "104593" ||
      listgenUserID === "105473" ||
      listgenUserID === "102975" ||
      listgenUserID === "104504" ||
      listgenUserID === "105785" ||
      listgenUserID === "104480" ||
      listgenUserID === "105830" ||
      listgenUserID === "104804"
    ) {
      logoHeight = "agent-logo-height-80-width-234";
    } else if (listgenUserID === "100585") {
      logoHeight = "logo-style-lg";
    } else if (listgenUserID === "106531") {
      logoHeight = "agent-logo-height-90-width-265";
    }
    let agentPhotoStyle;
    let agentPhotoContainerStyle;
    if (isMarkWong) {
      //must keep due to sizing
      agentPhotoStyle = "agent-photo-margin-top-neg-14";
    } else if (listgenUserID === "104835") {
      agentPhotoStyle = "agent-photo-210-height-290-width";
    } else if (
      isJenMurry ||
      listgenUserID === "107319" ||
      isDaphneChou ||
      listgenUserID === "109657" ||
      listgenUserID === "110007" ||
      listgenUserID === "106655" ||
      listgenUserID === "106463"
    ) {
      agentPhotoStyle = "agent-photo-height-204-width-281";
    } else if (
      listgenUserID === "100411" ||
      listgenUserID === "100329" ||
      listgenUserID === "107012" ||
      listgenUserID === "106433" ||
      listgenUserID === "106399"
    ) {
      agentPhotoStyle = "agent-photo-height-171-width-258";
    } else if (
      listgenUserID === "x102753" ||
      listgenUserID === "107253" ||
      listgenUserID === "100656"
    ) {
      agentPhotoStyle = "agent-photo-height-185-width-265";
    } else if (listgenUserID === "106475") {
      agentPhotoStyle = "agent-photo-height-250-width-300";
      agentPhotoContainerStyle = "agent-photo-container-height-225-width-275";
    } else if (listgenUserID === "x104504") {
      agentPhotoStyle = "agent-photo-height-140-width-260";
    } else if (isKyle3Team === "x") {
      agentPhotoStyle = "agent-photo-less-margin-large-photo";
    } else if (listgenUserID === "101268") {
      agentPhotoStyle = "agent-photo-height-150-width-260";
    } else if (
      listgenUserID === "106991" ||
      listgenUserID === "104747" ||
      listgenUserID === "109954" ||
      listgenUserID === "113592"
    ) {
      agentPhotoStyle = "agent-photo-height-230-width-300";
      agentPhotoContainerStyle = "agent-photo-container-height-250-width-300";
    } else if (isMemberOfTeam) {
      agentPhotoStyle = "agent-photo-height-235-width-300";
      agentPhotoContainerStyle = "agent-photo-container-height-235-width-300";
    } else {
      // (
      //   listgenUserID === "105795" ||
      //   listgenUserID === "106397" ||
      //   listgenUserID === "106020" ||
      //   listgenUserID === "104747" ||
      //   listgenUserID === "106543" ||
      //   listgenUserID === "102734" ||
      //   listgenUserID === "105918" ||
      //   listgenUserID === "105227" ||
      //   listgenUserID === "106141" ||
      //   isKyle3Team ||
      //   listgenUserID === "102340" ||
      //   (mlsAreaID.includes("ALA") && listgenUserID !== "107319") ||
      //   listgenUserID === "106024"
      // )

      agentPhotoStyle = "agent-photo-height-250-width-300";
      agentPhotoContainerStyle = "agent-photo-container-height-250-width-300";
    }
    let useFullName = false;
    if (
      listgenUserID === "117968" ||
      listgenUserID === "120441" ||
      listgenUserID === "102567" ||
      listgenUserID === "102734" ||
      listgenUserID === "114384" ||
      listgenUserID === "109938" ||
      listgenUserID === "109973" ||
      listgenUserID === "102809" ||
      listgenUserID === "100401" ||
      listgenUserID === "100474" ||
      listgenUserID === "107232" ||
      listgenUserID === "107243" ||
      listgenUserID === "107294" ||
      listgenUserID === "105047" ||
      listgenUserID === "106463" ||
      isJenMurry ||
      listgenUserID === "109652" ||
      listgenUserID === "109651" ||
      listgenUserID === "107300" ||
      listgenUserID === "106475" ||
      listgenUserID === "106991" ||
      listgenUserID === "107248" ||
      listgenUserID === "109954" ||
      listgenUserID === "110007" ||
      listgenUserID === "109989" ||
      listgenUserID === "112336" ||
      listgenUserID === "104782" ||
      listgenUserID === "109834" ||
      listgenUserID === "112352" ||
      listgenUserID === "106655" ||
      listgenUserID === "107001" ||
      listgenUserID === "113015" ||
      listgenUserID === "113599" ||
      listgenUserID === "114393" ||
      listgenUserID === "115902" ||
      listgenUserID === "113650" ||
      listgenUserID === "116929" ||
      listgenUserID === "120437" ||
      listgenUserID === "120423"
    ) {
      useFullName = true;
    }
    //adding comment

    if (listgenUserID === "105047" || listgenUserID === "109834") {
      displayEmailAddress = emailAddress = "";
    }
    let showPhoneNumber = true;
    if (listgenUserID === "109834" || listgenUserID === "112352") {
      showPhoneNumber = false;
    }
    let smallFontBrokerage =
      filteredBrokerage.length > 40 && !singleAgent2LineBerkshire
        ? true
        : false;

    let switchOrder = false;
    // let switchOrder = listgenUserID === "106028";
    // let switchOrder = listgenUserID === "106028";
    let editorOrPrint = printVersion ? "print-" : "editor-";
    let adjacentAgentNameStyles = "";
    if (listgenUserID === "109982") {
      adjacentAgentNameStyles = "bolded-name";
    } else if (listgenUserID === "102734") {
      adjacentAgentNameStyles = "adjacent-name-font-28-bold-600";
    }
    let taglineStyles = "";
    if (mlsAreaID === "SCL-13F") {
      taglineStyles = "tagline-font-16-font-600";
    }
    let secondTaglineStyles;
    if (mlsAreaID === "SCL-16M") {
      secondTaglineStyles = "italicized-no-bold-tagline";
    }
    let isPaigeT = listgenUserID === "112993";
    let paigeTAgentInfo = (
      <div className="contact-section-single-row">
        <div className="paige-t-back-page-logo-container">
          <img
            src="https://d2onbxnrte2nim.cloudfront.net/non-covers/021726_PaigeTitus_LOGO.jpg"
            alt="Paige Titus Logo"
            className="paige-t-back-page-logo"
          />
        </div>
        <div className="contact-section-single">
          <div
            className={`contact-me contact-me-single-inner ${contactMeStyles}`}
          >
            <span className={`adjacent-agent-name ${adjacentAgentNameStyles}`}>
              {listgenUserFirstName} {listgenUserLastName}
            </span>
            {mobilePhoneNo.slice(0, 3)} <div className="contact-me-circle" />{" "}
            {mobilePhoneNo.slice(3, 6)} <div className="contact-me-circle" />{" "}
            {mobilePhoneNo.slice(6)}
          </div>
          <div className="stacked-address single-agent">
            <div className={`address-col ${emailStyles}`}>
              <div className="office-address-container">
                <p className="office-address">
                  {displayEmailAddress ? displayEmailAddress : emailAddress}
                </p>
              </div>
            </div>

            {specialSignatureText
              ? formatTagline(
                  specialSignatureText,
                  "",
                  `special-berkshire special-mt ${taglineStyles}`,
                )
              : ""}
          </div>
        </div>
      </div>
    );
    let isChristineC = listgenUserID === "116385";
    let christineCAgentInfo = (
      <div className={`${editorOrPrint}qv4-logo-and-avatar-container-0-margin`}>
        <div className="custom-agent-logo-avatar">
          <img
            src="https://d2onbxnrte2nim.cloudfront.net/non-covers/060826_ChristineChristiansen_AgentBlk.png"
            alt="Christine Christiansen June 2026 update 3"
          />
        </div>
      </div>
    );

    let isChristineAndKelly = listgenUserID === "116388";
    let christineAndKellyAgentInfo = (
      <div className={`${editorOrPrint}qv4-logo-and-avatar-container-0-margin`}>
        <div className="custom-agent-logo-avatar">
          <img
            src="https://d2onbxnrte2nim.cloudfront.net/non-covers/060826-2_KellyE-ChristineC_AgentBlk.png"
            alt="Christine and KellyJune 2026 update"
          />
        </div>
      </div>
    );

    let isSarahSF = listgenUserID === "x116941";
    let sarahSFAgentInfo = (
      <div className={`${editorOrPrint}qv4-logo-and-avatar-container-0-margin`}>
        <div className="custom-agent-logo-avatar">
          <img
            src="https://d2onbxnrte2nim.cloudfront.net/non-covers/082526_SarahSullivan-Compass-headshot.jpg"
            alt="Sarah Sullivan August 2026 update"
          />
        </div>
      </div>
    );

    let useLiborioM = listgenUserID === "104519";
    const renderLiborioMContent = () => (
      <div
        className={`logo-and-avatar-team-contact ${backpageAgentInfoStyles}`}
      >
        <div className="contact-section-team">
          <div className="contact-me-team-container">
            <div className="contact-me-team-inner">
              <div className="contact-me row">
                <p>
                  {teamMembers[1]?.firstName} | {listgenUserFirstName}{" "}
                </p>
              </div>

              <div className="contact-me row">
                <p>{formatPhoneNoWithDashes(mobilePhoneNo)}</p>
              </div>
            </div>
          </div>
          <div className="stacked-address">
            <div className={`address-col team-email-address ${emailStyles}`}>
              {displayEmailAddress ? displayEmailAddress : emailAddress}
            </div>
            {specialSignatureText &&
              formatTagline(
                specialSignatureText,
                "address-city-mt",
                `address-city special-mt special-berkshire ${smallerSignature} ${taglineStyles}`,
              )}
          </div>
        </div>
      </div>
    );
    if (isChristineC) {
      return christineCAgentInfo;
    } else if (isChristineAndKelly) {
      return christineAndKellyAgentInfo;
    } else if (isSarahSF) {
      return sarahSFAgentInfo;
    } else if (isKimmAndJennifer) {
      return (
        <div
          className={`${editorOrPrint}qv4-logo-and-avatar-container ${logoMargin} kimm-jennifer-logo-avatar-container ${compassLayoutClass}`}
        >
          {logoURL && (
            <div className={`left-upper-col-agent-logo  ${logoHeight}`}>
              <img src={logoURL} alt="Logo" />
            </div>
          )}

          {renderAgentPhoto({
            photoURL: isCompassAgent ? displayedCompassPhotoURL : photoURL,
            originalPhotoURL: photoURL,
            isCompassAgent,
            agentPhotoStyle,
            agentPhotoContainerStyle,
            agentData,
            listgenUserID,
            savedCrop: savedCompassCrop,
          })}

          <div
            className={`logo-and-avatar-team-contact ${backpageAgentInfoStyles}`}
          >
            <div className="contact-section-team">
              <div className="contact-me-team-container">
                <div className="contact-me-team-inner">
                  <div className="contact-me row">
                    <p>
                      {listgenUserFirstName} {listgenUserLastName}
                    </p>
                    <div className="contact-me-divider" />{" "}
                    <p>{formatPhoneNoWithPeriods(mobilePhoneNo)}</p>
                  </div>

                  <div className="contact-me row">
                    <p>
                      {teamMembers[1].firstName} {teamMembers[1].lastName}
                    </p>
                    <div className="contact-me-divider" />{" "}
                    <p>{formatPhoneNoWithPeriods(teamMembers[1].phone)}</p>
                  </div>
                </div>
              </div>
              <div className="stacked-address">
                {specialSignatureText &&
                  formatTagline(
                    specialSignatureText,
                    "address-city-mt",
                    `address-city special-mt special-berkshire ${smallerSignature} ${taglineStyles}`,
                  )}
                <div
                  className={`address-col team-email-address ${emailStyles}`}
                >
                  {displayEmailAddress ? displayEmailAddress : emailAddress}
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    } else if (isLynneMercer) {
      return (
        <div
          className={`${editorOrPrint}qv4-logo-and-avatar-container-0-margin`}
        >
          <div className="custom-agent-logo-avatar custom-mt-1">
            <img
              src="https://d2onbxnrte2nim.cloudfront.net/non-covers/020926_LynneM-CalebF_AgentBlock_2.jpg"
              alt="Logo"
            />
          </div>
        </div>
      );
    } else if (mlsAreaID === "SCL-1AC") {
      return (
        <div
          className={`${editorOrPrint}qv4-logo-and-avatar-container-0-margin top-15`}
        >
          <div className="custom-agent-logo-avatar">
            <img
              src="https://d2onbxnrte2nim.cloudfront.net/non-covers/031026_GaryPalacios_TEAMshot_2.jpg"
              alt="Logo"
            />
          </div>
        </div>
      );
    } else if (isAnnetteVait === "early2024") {
      return (
        <div
          className={`${editorOrPrint}qv4-logo-and-avatar-container-0-margin`}
        >
          <div className="custom-agent-logo-avatar">
            <img
              src="https://d2onbxnrte2nim.cloudfront.net/non-covers/021324_AnnetteVait_AgentBlock_300ppi_1.jpg"
              alt="Logo"
            />
          </div>
        </div>
      );
    } else if (listgenUserID === "x106463") {
      return (
        <div
          className={`${editorOrPrint}qv4-logo-and-avatar-container-0-margin`}
        >
          <div className="custom-agent-logo-avatar left-custom-photo-margin">
            <img
              src="https://d2onbxnrte2nim.cloudfront.net/non-covers/071924_BethPowers-Deb_AgentBlock_3.jpg"
              alt="Logo"
            />
          </div>
        </div>
      );
    } else if (listgenUserID === "100030") {
      return (
        <div
          className={`${editorOrPrint}qv4-logo-and-avatar-container-0-margin`}
        >
          <div className="custom-agent-logo-avatar">
            <img
              src="https://d2onbxnrte2nim.cloudfront.net/101624_Nate-TopProducer_300ppi-4in_4.jpg"
              alt="Logo"
            />
          </div>
        </div>
      );
    } else if (listgenUserID === "100040") {
      return (
        <div
          className={`${editorOrPrint}qv4-logo-and-avatar-container-0-margin`}
        >
          <div className="custom-agent-logo-avatar">
            <img
              src="https://d2onbxnrte2nim.cloudfront.net/non-covers/020526_AmberRussell_AgentBlock_v3.jpg"
              alt="Amber Russell Agent block Feb 2026"
            />
          </div>
        </div>
      );
    } else if (listgenUserID === "101566") {
      return (
        <div
          className={`${editorOrPrint}qv4-logo-and-avatar-container-0-margin`}
        >
          <div className="custom-gummow-agent-logo-avatar">
            <img
              src="https://d2onbxnrte2nim.cloudfront.net/031225_GummowBROs_crop.png"
              alt="Logo"
            />
          </div>
        </div>
      );
    } else if (isCindyAndrade) {
      return (
        <div
          className={`${editorOrPrint}qv4-logo-and-avatar-container ${logoMargin} cindy-andrade-logo-avatar ${compassLayoutClass}`}
        >
          <div className="cindy-logo-avatar-col-1">
            <div className="contact-me contact-me-single-inner double-name">
              <div className="contact-me col">
                <p className="large-bolded-contact">
                  {listgenUserFirstName} {listgenUserLastName}
                </p>
              </div>
            </div>

            {renderAgentPhoto({
              photoURL: isCompassAgent
                ? this.state.croppedHeadshotURL ||
                  agentData.croppedHeadshotURL ||
                  "https://d2onbxnrte2nim.cloudfront.net/non-covers/cindy-andrade-headshot.png"
                : "https://d2onbxnrte2nim.cloudfront.net/non-covers/cindy-andrade-headshot.png",
              originalPhotoURL:
                "https://d2onbxnrte2nim.cloudfront.net/non-covers/cindy-andrade-headshot.png",
              isCompassAgent,
              agentPhotoStyle,
              extraPhotoClass:
                listgenUserID === "100526" || listgenUserID === "100138"
                  ? "larger-agent-photo"
                  : "",
              extraContainerClass: "align-bottom-photo-container",
              agentData,
              listgenUserID,
              savedCrop: savedCompassCrop,
            })}
            <div className="contact-section-single">
              <div
                className={`contact-me contact-me-single-inner ${contactMeStyles}`}
              >
                {mobilePhoneNo.slice(0, 3)}{" "}
                <div className="contact-me-circle" />{" "}
                {mobilePhoneNo.slice(3, 6)}{" "}
                <div className="contact-me-circle" /> {mobilePhoneNo.slice(6)}
              </div>
              <div className="stacked-address single-agent">
                <div className="address-col">
                  <div className="office-address-container">
                    <p className="office-address">
                      {displayEmailAddress ? displayEmailAddress : emailAddress}
                    </p>
                  </div>
                </div>
                {specialSignatureText &&
                  formatTagline(
                    specialSignatureText,
                    "address-city-mt",
                    `address-city special-berkshire special-mt ${taglineStyles}`,
                  )}
              </div>
            </div>
          </div>
          <div className="cindy-logo-avatar-col-2">
            <div className={`special-no-margin-agent-logo`}>
              <img src={logoURL} alt="Logo" />
            </div>
          </div>
        </div>
      );
    } else if (listgenUserID === "100528") {
      return (
        <div
          className={`${editorOrPrint}qv4-logo-and-avatar-container ${logoMargin} small-height-logo-and-avatar ${compassLayoutClass}`}
        >
          <div className={`left-upper-col-agent-logo ${logoHeight}`}>
            <img src={logoURL} alt="Logo" />
          </div>
          {renderAgentPhoto({
            photoURL: isCompassAgent ? displayedCompassPhotoURL : photoURL,
            originalPhotoURL: photoURL,
            isCompassAgent,
            extraPhotoClass: "med-agent-photo",
            agentData,
            listgenUserID,
            savedCrop: savedCompassCrop,
          })}
          <div className="contact-section-single double-name-container">
            <div className="contact-me contact-me-single-inner double-name">
              <div className="contact-me col">
                <p className="capitalized-contact">
                  {listgenUserFirstName} {listgenUserLastName}
                </p>
              </div>
            </div>
            <div
              className={`contact-me contact-me-single-inner ${contactMeStyles}`}
            >
              {mobilePhoneNo.slice(0, 3)} <div className="contact-me-circle" />{" "}
              {mobilePhoneNo.slice(3, 6)} <div className="contact-me-circle" />{" "}
              {mobilePhoneNo.slice(6)}
            </div>
            <div className="stacked-address single-agent">
              {specialSignatureText &&
                formatTagline(
                  specialSignatureText,
                  "address-city-mt",
                  `address-city  special-berkshire special-mt ${taglineStyles}`,
                )}
            </div>
          </div>
        </div>
      );
      // return (
      //   <div className={`${editorOrPrint}qv4-logo-and-avatar-container`}>
      //     <>
      //       <img
      //         src="https://d2onbxnrte2nim.cloudfront.net/final-500px-douglas-logo.png"
      //         alt="Douglas logo and avatar"
      //         className="douglas-logo-and-avatar"
      //       />
      //     </>
      //   </div>
      // );
    } else {
      return (
        <div
          className={`${editorOrPrint}qv4-logo-and-avatar-container ${logoMargin} ${compassLayoutClass}`}
        >
          {listgenUserID === "107253" ||
            (listgenUserID === "114384" && (
              <div className={`left-upper-col-agent-logo  ${logoHeight}`}>
                <img src={logoURL} alt="Logo" />
              </div>
            ))}
          {/*{" "}
          {logoURL &&
            (!mlsAreaID.includes("ALA") || listgenUserID === "107319") &&
            listgenUserID !== "102340" &&
            listgenUserID !== "106991" &&
            listgenUserID !== "105795" &&
            listgenUserID !== "102734" &&
            listgenUserID !== "105918" &&
            listgenUserID !== "106543" &&
            !isWendyLeung &&
            !isKyle3Team &&
            listgenUserID !== "x106991" &&
            listgenUserID !== "105227" &&
            listgenUserID !== "106020" &&
            listgenUserID !== "104835" &&
            listgenUserID !== "106397" &&
            listgenUserID !== "104747" &&
            listgenUserID !== "106141" &&
            listgenUserID !== "106024" &&
            !isDaphneChou && (
              <div className={`left-upper-col-agent-logo  ${logoHeight}`}>
                <img src={logoURL} alt="Logo" />
              </div>
            )}
          */}
          {renderAgentPhoto({
            photoURL: isCompassAgent ? displayedCompassPhotoURL : photoURL,
            originalPhotoURL: photoURL,
            isCompassAgent,
            agentPhotoStyle,
            agentPhotoContainerStyle,
            extraPhotoClass:
              listgenUserID === "100526" ||
              listgenUserID === "100138" ||
              isColleenForaker
                ? "larger-agent-photo"
                : "",
            agentData,
            listgenUserID,
            savedCrop: savedCompassCrop,
          })}
          {listgenUserID === "106655" && (
            <div className="jeff-lang-qr-container">
              <div className="jeff-lang-qr-text-container">
                <p>Scan here for my latest videos</p>
              </div>
              <img
                src="https://d2onbxnrte2nim.cloudfront.net/non-covers/011326_JeffLang_QR.jpg"
                alt="Jeff Lang QR Code"
                className="jeff-lang-qr-image"
              />
            </div>
          )}
          {isWendyLeung && (
            <div className={`left-upper-col-agent-logo ${logoHeight}`}>
              <img src={logoURL} alt="Logo" />
            </div>
          )}
          {listgenUserID === "106655" ? (
            <div className="contact-section-single">
              <div className="contact-me contact-me-single-inner">
                <span
                  className={`adjacent-agent-name ${adjacentAgentNameStyles}`}
                >
                  {listgenUserFirstName} {useFullName && listgenUserLastName}
                </span>
                {mobilePhoneNo.slice(0, 3)}{" "}
                <div className="contact-me-circle" />{" "}
                {mobilePhoneNo.slice(3, 6)}{" "}
                <div className="contact-me-circle" /> {mobilePhoneNo.slice(6)}
              </div>
              <div className="stacked-address">
                {specialSignatureText &&
                  formatTagline(
                    specialSignatureText,
                    "",
                    `address-city  tagline-font-13-mt-neg-10-420-width ${taglineStyles}`,
                  )}
              </div>
            </div>
          ) : listgenUserID === "100656" ? (
            <div className={`lisa-mccollum-photo-and-qr`}>
              <div className="contact-section-single">
                <div className="lisa-mccollum-qr-text-container">
                  <p>Hi Neighbor! Scan below for my VIDEO message!</p>
                </div>
                {mlsAreaID !== "xSBA-10G" && (
                  <div className="lisa-mccollum-qr-container">
                    <img
                      src="https://d2onbxnrte2nim.cloudfront.net/non-covers/100426_QRcode_LisaMcCollum.png"
                      alt="Logo"
                    />
                  </div>
                )}
                <div className="contact-me contact-me-single-inner lisa-column">
                  <span
                    className={`adjacent-agent-name ${adjacentAgentNameStyles}`}
                  >
                    {listgenUserFirstName} {listgenUserLastName}
                  </span>
                  <span className="lisa-email">
                    lisa@homesinsantabarbara.com
                  </span>
                </div>
              </div>
            </div>
          ) : isKazemiTeam ? (
            <div className="logo-and-avatar-team-contact">
              <div className="contact-section-team">
                <div className="contact-me-team-container">
                  <div className="contact-me-team-inner">
                    <div className="contact-me row">
                      <p>
                        <p>{formatPhoneNoWithDashes(mobilePhoneNo)}</p>
                      </p>
                      <div className="contact-me-divider" />{" "}
                      <p>{listgenUserFirstName}</p>
                    </div>
                  </div>
                </div>
                <div className="stacked-address">
                  <div
                    className={`address-col team-email-address ${emailStyles}`}
                  >
                    {displayEmailAddress ? displayEmailAddress : emailAddress}
                  </div>

                  {specialSignatureText &&
                    formatTagline(
                      specialSignatureText,
                      "address-city-mt",
                      `address-city special-mt special-berkshire ${smallerSignature} ${taglineStyles}`,
                    )}
                </div>
              </div>
            </div>
          ) : isPerryGroup ? (
            <div className="logo-and-avatar-team-contact">
              <div className="contact-section-team">
                <div className="contact-me-team-container">
                  <div className="contact-me-team-inner">
                    <div className="contact-me row">
                      <p className="uppercased-contact">
                        {teamMembers[1].firstName} {teamMembers[1].lastName}
                      </p>
                      <div className="contact-me-divider" />{" "}
                      <div
                        className={`contact-me contact-me-single-inner ${contactMeStyles}`}
                      >
                        {teamMembers[1].phone.slice(0, 3)}{" "}
                        <div className="contact-me-circle" />{" "}
                        {teamMembers[1].phone.slice(3, 6)}{" "}
                        <div className="contact-me-circle" />{" "}
                        {teamMembers[1].phone.slice(6)}
                      </div>
                    </div>
                    <div className="contact-me row">
                      <p className="uppercased-contact">
                        {listgenUserFirstName} {listgenUserLastName}
                      </p>
                      <div className="contact-me-divider" />{" "}
                      <div
                        className={`contact-me contact-me-single-inner ${contactMeStyles}`}
                      >
                        {mobilePhoneNo.slice(0, 3)}{" "}
                        <div className="contact-me-circle" />{" "}
                        {mobilePhoneNo.slice(3, 6)}{" "}
                        <div className="contact-me-circle" />{" "}
                        {mobilePhoneNo.slice(6)}
                      </div>
                    </div>
                    <div className="small-text-contact">
                      <p>Former Mayor City of Monte Sereno</p>
                    </div>
                  </div>
                </div>
                <div className="stacked-address single-agent">
                  {specialSignatureText &&
                    formatTagline(
                      specialSignatureText,
                      "address-city-mt",
                      `address-city  special-berkshire special-mt ${taglineStyles}`,
                    )}
                </div>
              </div>
            </div>
          ) : listgenUserID === "xx100528" ? (
            <div className="logo-and-avatar-team-contact">
              <div className="contact-section-team">
                <div className="contact-me-team-container">
                  <div className="contact-me contact-me-single-inner">
                    {mobilePhoneNo.slice(0, 3)}{" "}
                    <div className="contact-me-circle" />{" "}
                    {mobilePhoneNo.slice(3, 6)}{" "}
                    <div className="contact-me-circle" />{" "}
                    {mobilePhoneNo.slice(6)}
                  </div>
                </div>
              </div>
            </div>
          ) : listgenUserID === "100411" ? (
            <div className="contact-section-single mccaw-ml">
              <div className="two-column-single-inner">
                <div className="two-column-single-inner-col">
                  <img
                    src="https://d2onbxnrte2nim.cloudfront.net/040323_Garret-MC_QRcode_500px.jpg"
                    alt="Garrett McCaw logo"
                    className="mccaw-qr-logo-and-avatar"
                  />
                </div>
                <div className="two-column-single-inner-col">
                  <div className="mccaw-contact-me-row">
                    <p className="mccaw-agent-name">{listgenUserFirstName}</p>
                    <p className="mccaw-agent-name phone-text">
                      {mobilePhoneNo.slice(0, 3)}{" "}
                      <span className="contact-me-circle" />{" "}
                      {mobilePhoneNo.slice(3, 6)}{" "}
                      <span className="contact-me-circle" />{" "}
                      {mobilePhoneNo.slice(6)}
                    </p>
                  </div>

                  <div className="scan-text-container">
                    <p className="mccaw-scan-text">DO YOU KNOW WHAT</p>
                    <p className="mccaw-scan-text">YOUR HOME IS WORTH?</p>
                  </div>
                </div>

                {/*<p className="mccaw-scan-text">with a free market analysis</p>*/}
              </div>
              <p className="mccaw-analysis-text">
                Scan here to find out with a free market analysis
              </p>
            </div>
          ) : listgenUserID === "ambers" ? (
            <div className="contact-section-single">
              <div className="address-col">
                <div className="office-address-container">
                  <p className="office-address">
                    Amber Russell & Robert Kerchner
                  </p>
                </div>
              </div>

              <div className="contact-me contact-me-single-inner">
                {mobilePhoneNo.slice(0, 3)}{" "}
                <div className="contact-me-circle" />{" "}
                {mobilePhoneNo.slice(3, 6)}{" "}
                <div className="contact-me-circle" /> {mobilePhoneNo.slice(6)}
              </div>
              <div className="stacked-address single-agent">
                <div className="address-col">
                  <div className="office-address-container centered">
                    <p className="office-address">BROKER OWNERS</p>
                    {/*<p className="office-address">{filteredBrokerage}</p>*/}
                  </div>
                </div>
              </div>
            </div>
          ) : listgenUserID === "100190" ? (
            <div className="logo-and-avatar-team-contact">
              <div className="contact-section-team">
                <div className="contact-me-team-container">
                  <div className="contact-me-team-inner">
                    <div className="contact-me row">
                      <p>
                        {useFullName
                          ? `${teamMembers[1].firstName} ${teamMembers[1].lastName}`
                          : teamMembers[1].firstName}
                      </p>
                      <div className="contact-me-divider" />{" "}
                      <p>{formatPhoneNoWithDashes(teamMembers[1].phone)}</p>
                    </div>

                    <div className="contact-me row contact-extra-mb">
                      <p>
                        {useFullName
                          ? `${listgenUserFirstName} ${listgenUserLastName}`
                          : listgenUserFirstName}
                      </p>
                      <div className="contact-me-divider" />{" "}
                      <p>{formatPhoneNoWithDashes(mobilePhoneNo)}</p>
                    </div>
                  </div>
                </div>
                <div className="stacked-address">
                  <div className="address-col team-email-address">
                    {displayEmailAddress ? displayEmailAddress : emailAddress}
                  </div>

                  {specialSignatureText &&
                    listgenUserID === "100190" &&
                    formatTagline(
                      specialSignatureText,
                      "address-city-mt",
                      `address-city special-mt special-berkshire ${taglineStyles}`,
                    )}
                </div>
              </div>
            </div>
          ) : switchOrder ? (
            <div className="logo-and-avatar-team-contact">
              <div className="contact-section-team">
                <div className="contact-me-team-container">
                  <div className="contact-me-team-inner">
                    <div className="contact-me row">
                      <p>
                        {useFullName
                          ? `${teamMembers[1].firstName} ${teamMembers[1].lastName}`
                          : teamMembers[1].firstName}
                      </p>
                      <div className="contact-me-divider" />{" "}
                      <p>{formatPhoneNoWithDashes(teamMembers[1].phone)}</p>
                    </div>

                    <div className="contact-me row">
                      <p>
                        {useFullName
                          ? `${listgenUserFirstName} ${listgenUserLastName}`
                          : listgenUserFirstName}
                      </p>
                      <div className="contact-me-divider" />{" "}
                      <p>{formatPhoneNoWithDashes(mobilePhoneNo)}</p>
                    </div>
                  </div>
                </div>
                <div className="stacked-address">
                  <div
                    className={`address-col team-email-address ${emailStyles}`}
                  >
                    {displayEmailAddress ? displayEmailAddress : emailAddress}
                  </div>

                  {specialSignatureText &&
                    formatTagline(
                      specialSignatureText,
                      "address-city-mt",
                      `address-city special-mt special-berkshire ${smallerSignature} ${taglineStyles}`,
                    )}
                </div>
              </div>
            </div>
          ) : listgenUserID === "x109864" ? (
            <div
              className={`logo-and-avatar-team-contact ${backpageAgentInfoStyles}`}
            >
              <div className="contact-section-team">
                <div className="contact-me-team-container">
                  <div className="contact-me-team-inner">
                    <div className="contact-me row">
                      <p>
                        {" "}
                        *
                        {useFullName
                          ? `${teamMembers[2].firstName} ${teamMembers[2].lastName}`
                          : teamMembers[2].firstName}
                      </p>
                      <div className="contact-me-divider" />{" "}
                      <p>{formatPhoneNoWithDashes(teamMembers[2].phone)}</p>
                    </div>

                    <div className="contact-me row">
                      <p>
                        {" "}
                        {useFullName
                          ? `${listgenUserFirstName} ${listgenUserLastName}`
                          : listgenUserFirstName}
                      </p>
                      <div className="contact-me-divider" />{" "}
                      <p>{formatPhoneNoWithDashes(mobilePhoneNo)}</p>
                    </div>

                    <div className="contact-me row">
                      <p>
                        {" "}
                        {useFullName
                          ? `${teamMembers[1].firstName} ${teamMembers[1].lastName}`
                          : teamMembers[1].firstName}
                      </p>
                      <div className="contact-me-divider" />{" "}
                      <p>{formatPhoneNoWithDashes(teamMembers[1].phone)}</p>
                    </div>
                  </div>
                </div>
                <div className="stacked-address">
                  {specialSignatureText &&
                    formatTagline(
                      specialSignatureText,
                      "address-city-mt",
                      `address-city special-mt special-berkshire ${smallerSignature} ${taglineStyles}`,
                    )}
                </div>
              </div>
            </div>
          ) : isTeamOf3 ? (
            <div
              className={`logo-and-avatar-team-contact ${backpageAgentInfoStyles}`}
            >
              <div className="contact-section-team">
                <div className="contact-me-team-container">
                  <div className="contact-me-team-inner">
                    <div className="contact-me row">
                      <p>
                        {useFullName
                          ? `${listgenUserFirstName} ${listgenUserLastName}`
                          : listgenUserFirstName}
                      </p>
                      <div className="contact-me-divider" />{" "}
                      <p>{formatPhoneNoWithDashes(mobilePhoneNo)}</p>
                    </div>

                    <div className="contact-me row">
                      <p>
                        {" "}
                        {useFullName
                          ? `${teamMembers[1].firstName} ${teamMembers[1].lastName}`
                          : teamMembers[1].firstName}
                      </p>
                      <div className="contact-me-divider" />{" "}
                      <p>{formatPhoneNoWithDashes(teamMembers[1].phone)}</p>
                    </div>

                    <div className="contact-me row">
                      <p>
                        {" "}
                        {useFullName
                          ? `${teamMembers[2].firstName} ${teamMembers[2].lastName}`
                          : teamMembers[2].firstName}
                      </p>
                      <div className="contact-me-divider" />{" "}
                      <p>{formatPhoneNoWithDashes(teamMembers[2].phone)}</p>
                    </div>
                  </div>
                </div>
                <div className="stacked-address">
                  {listgenUserID === "114847" ? (
                    <div
                      className={`address-col team-email-address ${emailStyles}`}
                    >
                      {websiteURL}
                    </div>
                  ) : null}
                  {specialSignatureText &&
                    formatTagline(
                      specialSignatureText,
                      "address-city-mt",
                      `address-city special-mt special-berkshire ${smallerSignature} ${taglineStyles}`,
                    )}
                </div>
              </div>
            </div>
          ) : isKyle3Team ? (
            <div
              className={`logo-and-avatar-team-contact ${backpageAgentInfoStyles}`}
            >
              <div className="contact-section-team">
                <div className="contact-me-team-container">
                  <div className="contact-me-team-inner">
                    <div className="contact-me row">
                      <p>{teamMembers[2].firstName}</p>
                      <div className="contact-me-divider" />{" "}
                      <p>{formatPhoneNoWithDashes(teamMembers[2].phone)}</p>
                    </div>

                    <div className="contact-me row">
                      <p>{listgenUserFirstName}</p>
                      <div className="contact-me-divider" />{" "}
                      <p>{formatPhoneNoWithDashes(mobilePhoneNo)}</p>
                    </div>

                    <div className="contact-me row">
                      <p>{teamMembers[1].firstName}</p>
                      <div className="contact-me-divider" />{" "}
                      <p>{formatPhoneNoWithDashes(teamMembers[1].phone)}</p>
                    </div>
                  </div>
                </div>
                <div className="stacked-address">
                  {specialSignatureText &&
                    formatTagline(
                      specialSignatureText,
                      "address-city-mt",
                      `address-city special-mt special-berkshire ${smallerSignature} ${taglineStyles}`,
                    )}
                </div>
              </div>
            </div>
          ) : listgenUserID === "107303" ? (
            <div
              className={`logo-and-avatar-team-contact ${backpageAgentInfoStyles} team-column-layout`}
            >
              <div className="contact-section-team">
                <div className="contact-me-team-container">
                  <div className="contact-me-team-inner">
                    <div className="team-column">
                      <div
                        className={`contact-me row ${secondRowContactMeStyles}`}
                      >
                        <p>
                          {useFullName
                            ? `${teamMembers[1].firstName} ${teamMembers[1].lastName}`
                            : teamMembers[1].firstName}
                        </p>

                        <p>{formatPhoneNoWithDashes(teamMembers[1].phone)}</p>
                      </div>
                      <div className="stacked-address">
                        <div
                          className={`address-col team-email-address ${emailStyles}`}
                        >
                          {teamMembers[1].email}
                        </div>
                        <div className={`address-city-mt `}>
                          <div
                            className={`address-city address-city special-mt special-berkshire`}
                          >
                            MacDonaldRealEstate.org
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="team-column">
                      <div className="contact-me row">
                        <p>
                          {useFullName
                            ? `${listgenUserFirstName} ${listgenUserLastName}`
                            : listgenUserFirstName}
                        </p>

                        <p>{formatPhoneNoWithDashes(mobilePhoneNo)}</p>
                      </div>

                      <div className="stacked-address">
                        <div
                          className={`address-col team-email-address ${emailStyles}`}
                        >
                          {displayEmailAddress
                            ? displayEmailAddress
                            : emailAddress}
                        </div>

                        <div className={`address-city-mt `}>
                          <div
                            className={`address-city address-city special-mt special-berkshire `}
                          >
                            evatia.realestate
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : useLiborioM ? (
            renderLiborioMContent()
          ) : isMemberOfTeam &&
            !isScar &&
            listgenUserID !== "100027" &&
            !isJohnsons &&
            !isLeeShantePappas &&
            listgenUserID !== "104709" ? (
            <div
              className={`logo-and-avatar-team-contact ${backpageAgentInfoStyles}`}
            >
              <div className="contact-section-team">
                <div className="contact-me-team-container">
                  <div className="contact-me-team-inner">
                    {showPhoneNumber ? (
                      <div className="contact-me row">
                        <p>
                          {useFullName
                            ? `${listgenUserFirstName} ${listgenUserLastName}`
                            : listgenUserFirstName}
                        </p>
                        <div className="contact-me-divider" />{" "}
                        <p>{formatPhoneNoWithDashes(mobilePhoneNo)}</p>
                      </div>
                    ) : (
                      <div className="contact-me row">
                        <p>
                          {useFullName
                            ? `${listgenUserFirstName} ${listgenUserLastName}`
                            : listgenUserFirstName}
                        </p>
                      </div>
                    )}

                    {listgenUserID !== "104709" && showPhoneNumber ? (
                      <div
                        className={`contact-me row ${secondRowContactMeStyles}`}
                      >
                        <p>
                          {useFullName
                            ? `${teamMembers[1].firstName} ${teamMembers[1].lastName}`
                            : teamMembers[1].firstName}
                        </p>
                        <div className="contact-me-divider" />{" "}
                        <p>{formatPhoneNoWithDashes(teamMembers[1].phone)}</p>
                      </div>
                    ) : (
                      <div
                        className={`contact-me row ${secondRowContactMeStyles}`}
                      >
                        <p>
                          {useFullName
                            ? `${teamMembers[1].firstName} ${teamMembers[1].lastName}`
                            : teamMembers[1].firstName}
                        </p>
                      </div>
                    )}

                    {(listgenUserID === "101268" || isKyle3Team) && (
                      <div className="contact-me row">
                        <p>
                          {useFullName
                            ? `${teamMembers[2].firstName} ${teamMembers[2].lastName}`
                            : teamMembers[2].firstName}
                        </p>
                        <div className="contact-me-divider" />{" "}
                        <p>{formatPhoneNoWithDashes(teamMembers[2].phone)}</p>
                      </div>
                    )}
                  </div>
                </div>
                <div className="stacked-address">
                  {listgenUserID === "100129" && teamMembers ? (
                    <div className="address-col team-email-address">
                      {websiteURL}
                    </div>
                  ) : listgenUserID === "101003" ? (
                    <div className="address-col team-email-address">
                      <p>
                        {displayEmailAddress
                          ? displayEmailAddress
                          : emailAddress}
                      </p>

                      <p className="team-email-mt">kaitken@bhhscal.com</p>
                    </div>
                  ) : isJenMurry ? (
                    <div className="address-col team-email-address">
                      <p>{displayEmailAddress ? displayEmailAddress : ""}</p>

                      <p className="team-email-mt">vanomaurryteam.com</p>
                    </div>
                  ) : listgenUserID === "104504" ||
                    listgenUserID === "102545" ||
                    listgenUserID === "104747" ||
                    listgenUserID === "108341" ||
                    listgenUserID === "107303" ||
                    listgenUserID === "109954" ||
                    listgenUserID === "100658" ||
                    listgenUserID === "106463" ||
                    listgenUserID === "104793" ||
                    listgenUserID === "109680" ||
                    listgenUserID === "109788" ||
                    listgenUserID === "113597" ||
                    listgenUserID === "113592" ||
                    listgenUserID === "102689" ||
                    listgenUserID === "109818" ||
                    listgenUserID === "114383" ||
                    listgenUserID === "114393" ||
                    listgenUserID === "120543" ||
                    listgenUserID === "116936" ? (
                    <>
                      <div
                        className={`address-col team-email-address ${emailStyles}`}
                      >
                        {isMemberOfTeam && listgenUserID === "102689"
                          ? teamMembers[0].email
                          : isMemberOfTeam && listgenUserID === "104504"
                            ? teamMembers[0].email
                            : displayEmailAddress &&
                                listgenUserID !== "108341" &&
                                listgenUserID !== "114383"
                              ? displayEmailAddress
                              : emailAddress}
                      </div>

                      <div
                        className={`address-col team-email-address ${emailStyles}`}
                      >
                        {teamMembers[1].email}
                      </div>
                    </>
                  ) : (
                    <div
                      className={`address-col team-email-address ${emailStyles}`}
                    >
                      {listgenUserID === "100047" ||
                      listgenUserID === "100902" ||
                      isKyle3Team ||
                      isMarkWong ||
                      listgenUserID === "112352" ||
                      listgenUserID === "115901"
                        ? ""
                        : displayEmailAddress
                          ? displayEmailAddress
                          : emailAddress}
                    </div>
                  )}

                  {specialSignatureText &&
                    formatTagline(
                      specialSignatureText,
                      "address-city-mt",
                      `address-city special-mt special-berkshire ${smallerSignature} ${taglineStyles}`,
                    )}

                  {isMarkWong && (
                    <div className="backpage-designations-col">
                      <div>
                        <span className="backpage-designation-bold">SRES®</span>{" "}
                        - Senior Real Estate Specialist
                      </div>

                      <div>
                        <span className="backpage-designation-bold">CRS®</span>{" "}
                        - Certified Residential Specialist
                      </div>

                      <div>
                        <span className="backpage-designation-bold">ABR®</span>{" "}
                        - Accredited Buyer's Representative
                      </div>

                      <div>
                        <span className="backpage-designation-bold">QSC®</span>{" "}
                        - Quality Service Certified PLATINUM
                      </div>

                      <div>
                        <span className="backpage-designation-bold">CIPS®</span>{" "}
                        - Certified International Property Specialist
                      </div>

                      <div>
                        <span className="backpage-designation-bold">CGRS</span>{" "}
                        - Certified Global Relocation Specialist
                      </div>

                      <div>
                        <span className="backpage-designation-bold">CREN</span>{" "}
                        - Certified Real Estate Negotiator
                      </div>

                      <div>
                        <span className="backpage-designation-bold">NCS</span> -
                        New Construction Specialist
                      </div>

                      <div>
                        <span className="backpage-designation-bold">ASP®</span>{" "}
                        - Accredited Staging Professional
                      </div>
                    </div>
                  )}

                  {listgenUserID === "115901" && (
                    <div className="john-t-qr-code-container">
                      <img
                        src="https://d2onbxnrte2nim.cloudfront.net/non-covers/030726_JohnThompson_QRCode.jpg"
                        alt="John Thompson QR Code"
                      />
                    </div>
                  )}
                  {isDebKockos && (
                    <div className="contact-me row patty-dwyer-group-text">
                      <p>The Dwyer Group</p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          ) : isAnnetteVait ? (
            <div className="contact-section-single av-contact-section-single">
              <div className="contact-me contact-me-single-inner backpage-annette-phone-number">
                {mobilePhoneNo.slice(0, 3)}{" "}
                <div className="contact-me-circle" />{" "}
                {mobilePhoneNo.slice(3, 6)}{" "}
                <div className="contact-me-circle" /> {mobilePhoneNo.slice(6)}
              </div>
              <div className="stacked-address av-single-agent">
                <div className="address-col">
                  <div className="office-address-container">
                    <p className="office-address backpage-annette-office-address">
                      {displayEmailAddress ? displayEmailAddress : emailAddress}
                    </p>

                    {specialSignatureText &&
                      formatTagline(
                        specialSignatureText,
                        "address-city-mt",
                        `av-special-signature ${taglineStyles}`,
                      )}
                  </div>
                </div>
              </div>
            </div>
          ) : listgenUserID === "110007" ? (
            <div className="contact-section-single">
              <div className="contact-me contact-me-single-inner">
                <span
                  className={`adjacent-agent-name bolded-name ${adjacentAgentNameStyles}`}
                >
                  {listgenUserFirstName}{" "}
                  {(useFullName || isJohnForsythJames) && listgenUserLastName}
                </span>
              </div>

              <div className="address-city special-berkshire special-mt mb-5 ">
                "Service from the Heart"
              </div>

              <div className="contact-me contact-me-single-inner">
                {mobilePhoneNo.slice(0, 3)}{" "}
                <div className="contact-me-circle" />{" "}
                {mobilePhoneNo.slice(3, 6)}{" "}
                <div className="contact-me-circle" /> {mobilePhoneNo.slice(6)}
              </div>
              <div className="stacked-address single-agent">
                {listgenUserID !== "100474" && (
                  <div className={`address-col ${emailStyles}`}>
                    <div className="office-address-container">
                      <p className="office-address">
                        {displayEmailAddress
                          ? displayEmailAddress
                          : emailAddress}
                      </p>
                    </div>
                  </div>
                )}

                {specialSignatureText
                  ? formatTagline(
                      specialSignatureText,
                      "",
                      `special-berkshire special-mt ${taglineStyles}`,
                    )
                  : ""}
                <div className="address-city special-mt special-berkshire">
                  Certified Senior Advisor (CSA)® | SRES®
                </div>
                <div className="address-city special-mt special-berkshire">
                  Certified Trust & Probate Specialist
                </div>

                {singleAgent2LineBerkshire && !isMemberOfTeam ? (
                  <div></div>
                ) : (
                  <div
                    className={`address-city ${
                      smallFontBrokerage && "small-brokerage-text"
                    }`}
                  ></div>
                )}
              </div>
            </div>
          ) : isPaigeT ? (
            paigeTAgentInfo
          ) : (
            <div className="contact-section-single">
              <div
                className={`contact-me contact-me-single-inner ${contactMeStyles}`}
              >
                {isJohnsons ? (
                  <span className="adjacent-agent-name">
                    Dianne and Brianna
                  </span>
                ) : (
                  <span
                    className={`adjacent-agent-name ${adjacentAgentNameStyles}`}
                  >
                    {listgenUserID === "106145"
                      ? "Meg"
                      : listgenUserID !== "107019"
                        ? listgenUserFirstName
                        : ""}{" "}
                    {(listgenUserID === "103404" ||
                      listgenUserID === "100374" ||
                      listgenUserID === "103405" ||
                      listgenUserID === "106421" ||
                      listgenUserID === "106591" ||
                      listgenUserID === "105100" ||
                      listgenUserID === "105959" ||
                      listgenUserID === "105068" ||
                      useFullName ||
                      isJohnForsythJames) &&
                      listgenUserLastName}
                  </span>
                )}
                {mobilePhoneNo.slice(0, 3)}{" "}
                <div className="contact-me-circle" />{" "}
                {mobilePhoneNo.slice(3, 6)}{" "}
                <div className="contact-me-circle" /> {mobilePhoneNo.slice(6)}
              </div>
              <div className="stacked-address single-agent">
                {listgenUserID !== "100474" && (
                  <div className={`address-col ${emailStyles}`}>
                    <div className="office-address-container">
                      <p className="office-address">
                        {displayEmailAddress
                          ? displayEmailAddress
                          : emailAddress}
                      </p>
                    </div>
                  </div>
                )}
                {listgenUserID === "107300" && (
                  <div className="address-city special-berkshire special-mt non-bolded-address-city mb-neg-6">
                    WeChat: sensun5268
                  </div>
                )}

                {mlsAreaID === "106" ||
                mlsAreaID === "101" ||
                mlsAreaID === "100" ? (
                  <div className="address-city-mt">
                    <div className="address-city  special-berkshire special-mt">
                      Your Seaside Real Estate Specialist
                    </div>
                    <div className="address-city  special-berkshire special-mt">
                      Sí, Hablo Español
                    </div>
                  </div>
                ) : listgenUserID === "x100656" ? (
                  <div className="address-city-mt">
                    <div className="address-city special-berkshire special-mt">
                      #1 Team in Santa Barbara and Montecito
                    </div>

                    <div className="address-city special-berkshire special-mt non-bolded-address-city">
                      Follow me on Instagram @lisamccollumrealestate
                    </div>
                  </div>
                ) : specialSignatureText ? (
                  formatTagline(
                    specialSignatureText,
                    "",
                    `special-berkshire special-mt ${taglineStyles}`,
                  )
                ) : (
                  ""
                )}

                {singleAgent2LineBerkshire && !isMemberOfTeam ? (
                  <div></div>
                ) : (
                  <div
                    className={`address-city ${
                      smallFontBrokerage && "small-brokerage-text"
                    }`}
                  >
                    {isMaryAyers && (
                      <p className="portuguese-text">Eu falo Portugues!</p>
                    )}
                    {addWebsiteUnderSignature && (
                      <div className="address-city special-mt special-berkshire">
                        {websiteURL}
                      </div>
                    )}
                    {listgenUserID === "100474" && (
                      <p className="jessie-website-text">
                        JessieSessionsRealtor.com
                      </p>
                    )}
                    {listgenUserID === "100661" && (
                      <div className="address-city special-berkshire special-mt non-bolded-address-city">
                        Follow me on IG: @homesinSYV
                      </div>
                    )}

                    {listgenUserID === "102809" && (
                      <div className="address-city special-berkshire special-mt non-bolded-address-city">
                        Compass | Realtor® | DRE#: 02104764
                      </div>
                    )}
                  </div>
                )}
                {(listgenUserID === "100138" || listgenUserID === "105042") && (
                  <div className="address-city special-mt special-berkshire">
                    {websiteURL}
                  </div>
                )}
              </div>
              {isDaphneChou && (
                <div className={`left-upper-col-agent-logo  ${logoHeight}`}>
                  <img src={logoURL} alt="Logo" />
                </div>
              )}
              {isLoannT && (
                <div className={`loann-t-backpage-logo-container`}>
                  <img
                    className="loann-t-backpage-logo"
                    src={logoURL}
                    alt="Logo"
                  />
                </div>
              )}
            </div>
          )}
        </div>
      );
    }
  }
}

export default QVFourLogoAndAvatar;
